// extracted by mini-css-extract-plugin
export default {"logo":"index_logo_oyYl-","logoPic":"index_logoPic_MMFRP","banner":"index_banner_twRCM"};